// ///////////////////////////////////////////////////////
// Composant pour la gestion de la page les exterieurs
// ///////////////////////////////////////////////////////
// Creation : 25/07/2022    -> CGR
// ///////////////////////////////////////////////////////

// ///////////////////////////////////
// Imports

// Imports system
import React, { useContext, useEffect, useState, useRef } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"

// Import context
import {
  languageContext,
  noHeaderContext,
  pageContext,
  programmeContext,
} from "./../../contexts"

// Imports components
import { faEye } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import LinkedButton from "../../components/button/linkedButton"
import Toogle from "../../components/toggles/toggle"
import Pano from "./pano"
import Pano3D from "./pano3D"

// ///////////////////////////////////
// Component

const ExterieursLoading = () => {
  return (
    <div style = {{
      width: "100%",
      height: "100%",
      justifyContent: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"}}
    >
      <h2>Exterieurs</h2>
      <p>Chargement en cours</p>
    </div>
  )
}

const Exterieurs = ({fromMaquette = false, initialView = null}) => {

  const navigate = useNavigate()
  const { search } = useLocation()
  const noHeader = useContext(noHeaderContext);
  const lang = useContext(languageContext)
  const programmeDatas = useContext(programmeContext)
  const { setCurrent, setHeaderLevel } = useContext(pageContext)
  const extDatas = programmeDatas.pagesDetails.exterieurs
  // Fonctionnement krPano
  const [direction, setDirection] = useState(0);
  const [initialDir, setInitialDir] = useState(1000);
  const [miniMapStyle, setMiniMapStyle] = useState("normal");
  const miniMapSize = miniMapStyle === "normal" ? 320 : document.body.clientHeight;
  // Initials params
  const {vue, scene, variante} = useParams()
  const [forcedDirection, setForcedDirection] = useState(null)
  const fromPano = useRef(false)


  useEffect(() => {

    if (!extDatas) {return}

    if (!fromMaquette) {
      setCurrent(`exterieurs`);
      setHeaderLevel(1);
      setTimeout(() => { // Pour les chargement un peu lent, test un peu plus tardif
          setCurrent("exterieurs");
      }, (200));
    }

    if (!vue) {
      navigate(`${extDatas.views[0].title[lang]}/0/${extDatas.variantes[0].name[lang]}`)
      return
    }
  }, [extDatas, vue])

  useEffect(() => {
    if (extDatas && extDatas.vimType === "Standard") {
      window.somVar = (name) => {

        const to = extDatas.views.filter(datas => datas.views[0].id === parseInt(name.split("-")[1]))[0];        
        if (to) {
          if (!initialView) {
            navigate(
              `/${programmeDatas.urlName}/exterieurs/${to.title[lang]}/0/${variante}${search}`
            );
          }
        }

        
      };
    }
  }, [extDatas, variante]);

  useEffect(() => {

    if (extDatas.vimType !== "Navigation 3D") {

        document.addEventListener('click', e => {

            const x = e.x
            const y = e.y
            const width = document.body.clientWidth
            const height = document.body.clientHeight

            if (height > 599) {
                if (miniMapStyle === "normal") {
                    if (width - x > 40 && width - x < 360 && y > 10 && y < 330) {
                        setMiniMapStyle('full')
                    }
                } else {
                    if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                        setMiniMapStyle('normal')
                    }
                }
            }
            else {
                if (miniMapStyle === "normal") {
                    if (width - x > 29 && width - x < 172 && y > 28 && y < 172) {
                        setMiniMapStyle('full')
                    }
                } else {
                    if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                        setMiniMapStyle('normal')
                    }
                }
            }

            
        })

        //
        document.addEventListener('touchend', e => {

            const x = e.x
            const y = e.y
            const width = document.body.clientWidth
            const height = document.body.clientHeight

            if (height > 599) {
                if (miniMapStyle === "normal") {
                    if (width - x > 40 && width - x < 360 && y > 10 && y < 330) {
                        setMiniMapStyle('full')
                    }
                } else {
                    if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                        setMiniMapStyle('normal')
                    }
                }
            }
            else {
                if (miniMapStyle === "normal") {
                    if (width - x > 29 && width - x < 172 && y > 28 && y < 172) {
                        setMiniMapStyle('full')
                    }
                } else {
                    if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                        setMiniMapStyle('normal')
                    }
                }
            }

            
        })
    }

  }, [miniMapStyle])

  
  const setMiniMapSize = () => {

    setMiniMapStyle(old => {
        if (old === "normal") {
            return 'full'
        } else {
            return "normal"
        }
    })
}

  if (!vue || !scene || !variante) {
    return (<ExterieursLoading />)
  }

  return (
    <div id="exterieurs">

      {/* Palette de selection des variantes */}
      {extDatas.variantes.length !== 1 && (
        <div id="exterieursControllers">
          {!initialView && extDatas.variantes.map(v => <LinkedButton
              route={`/${programmeDatas.urlName}/exterieurs/${vue}/0/${v.name[lang]}${search}`}
              icon={v.icon}
              text={v.name[lang]}
              state={variante ===  v.name[lang]}
              displayText={programmeDatas.displayText}
            ></LinkedButton>
          )}
        </div>
      )}

      {/* Palette de selection de vue */}
      {!fromMaquette && (
        <div id = 'exterieursNavigation' className = {`${extDatas.variantes.length === 1 ? "novars" : ""} ${noHeader ? "noheader" : ""}`}>
          <Toogle
            list={extDatas.views.filter(v => v.displayInUi).map(v => {return {
              icon: null,
              text: v.title[lang],
              direction: v.title[lang],
            }})}
            current={vue}
            setCurrent={e => { fromPano.current = false; navigate(`/${programmeDatas.urlName}/exterieurs/${e}/0/${variante}${search}`)}}
            from="direction"
          />
        </div>
      )}    

      {/* PANO */}
      {extDatas.vimType === "Navigation 3D" && 
        <Pano3D
          view = {extDatas.views.find(x => x.title[lang] === vue)}
          variante = {extDatas.variantes.find(x => x.name[lang] === variante)}
          scene = {extDatas.views.find(x => x.title[lang] === vue).views[scene]}
          count = {extDatas.views.length}
          setDirection = {setDirection}
          setInitialDir = {setInitialDir}
          forcedDirection = {forcedDirection}
          fromPano = {fromPano}
        />
      }

      {extDatas.vimType !== "Navigation 3D" && 
        <Pano
          view = {extDatas.views.find(x => x.title[lang] === vue)}
          variante = {extDatas.variantes.find(x => x.name[lang] === variante)}
          scene = {extDatas.views.find(x => x.title[lang] === vue).views[scene]}
          count = {extDatas.views.length}
          setDirection = {setDirection}
          setInitialDir = {setInitialDir}
        />
      }


      {/* MINIMAP */}
      {extDatas.useMinimap && (
         <div id="panoMiniMap" className={miniMapStyle} onClick = {e => {if (extDatas.vimType === "Navigation 3D") {e.stopPropagation() ; setMiniMapSize()} else {}}}>
           <img
             src={`/public/programmes/${programmeDatas.name}/exterieurs/minimap${variante}.png`}
           ></img>

           {extDatas.miniMapPois.map((piece) => (
             <div 
              className={`minimapButton ${extDatas.views.find(x => x.title[lang] === vue)?.id === parseInt(piece.link?.split("-")[0]) ? "activRoom" : ""}`}
              onClick={(e) => {
                 e.stopPropagation();
                 fromPano.current = false
                 if (!initialView) {
                   navigate(`/${programmeDatas.urlName}/exterieurs/${extDatas.views.find(x => x.id === parseInt(piece.link?.split("-")[0])).title[lang]}/0/${variante}${search}`);
                 }
                 setMiniMapStyle("normal");
               }}
               style={{
                 left: `${(miniMapSize * piece.x) / 100}px`,
                 top: `${(miniMapSize * piece.y) / 100}px`,
               }}
             >
               {extDatas.views.find(x => x.title[lang] === vue)?.id === parseInt(piece.link?.split("-")[0]) && (
                 <div
                   className="visioCone"
                   style={{
                     rotate: `${piece.offset - (extDatas.vimType !== "Navigation 3D" ? initialDir : 0) + direction}deg`,
                   }}
                 >
                   <svg
                     width="82"
                     height="82"
                     style={{
                       position: "absolute",
                       left: "-16px",
                       top: "-16px",
                       pointerEvents: "none",
                     }}
                   >
                     <path
                       stroke={programmeDatas.color}
                       stroke-width="1"
                       stroke-opacity="0.45"
                       fill={programmeDatas.color}
                       fill-opacity="0.45"
                       d="M 40.5,40.5 L 26.894271311943584,77.04974893028677 A 39,39 0 0 1 15.649853268456681,10.442218854001098 Z"
                       style={{
                         cursor: "pointer",
                         transform: "scale(1, 1)",
                         pointerEvents: "none",
                       }}
                     ></path>
                   </svg>
                 </div>
               )}
               <FontAwesomeIcon icon={faEye} />
             </div>
           ))}
         </div>
       )}


    </div>
  )
}

export default Exterieurs;
